import { BadgeColor } from '@billy/design-system'

import { RecurringInvoiceStatus } from '@features/recurringInvoices/enums/recurringInvoiceStatus'

export const recurringInvoiceStatusToBadgeColor: Record<RecurringInvoiceStatus, BadgeColor> = {
  [RecurringInvoiceStatus.All]: 'neutral',
  [RecurringInvoiceStatus.Draft]: 'accent',
  [RecurringInvoiceStatus.Ongoing]: 'success',
  [RecurringInvoiceStatus.Paused]: 'warning',
  [RecurringInvoiceStatus.Completed]: 'neutral',
}
